<template>
  <layout name="LayoutLogin">
    <v-row justify="end" no-gutters class="fill-height">
      <v-col cols="12" lg="8" class="d-none d-lg-block">
        <div class="notfound-image"></div>
      </v-col>
      <v-col cols="12" lg="4" class="white d-flex align-center">
        <v-row justify="center">
          <v-col lg="9">
            <div class="text-center">
              <SvgLogo class="mx-auto mb-1" width="188" iconType="StrixLogo" />
              <h1 class="secondary--text">{{ $t('Portal.notFound.title') }}</h1>
              <p class="secondary--text mb-8">
                {{ $t('Portal.notFound.subtitle') }}
              </p>
              <v-btn
                class="text-uppercase"
                dark
                color="deepSkyBlue"
                block
                rounded
                height="48"
                :to="{ path: '/portal' }"
                >{{ $t('Portal.notFound.back') }}</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </layout>
</template>

<script>
import Layout from '@/layouts/Layout'
import { SvgLogo } from '@leapsight/styleguide'
export default {
  name: 'NotFound',
  components: {
    Layout,
    SvgLogo
  }
}
</script>

<style scoped>
.notfound-image {
  background-image: url('../assets/bg-valid-mail.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background-position: 0% 0%;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
